// extracted by mini-css-extract-plugin
export default {"jenga-item":"jenga-item_jenga-item__1n8tE","title":"jenga-item_title__Pkl41","body":"jenga-item_body__1LsTL"};